/**
 * Pêche aux indices : l'élève sélectionne, parmi TOUS les indices de l'énoncé,
 * ceux qu'il juge utiles pour le nœud courant. La pertinence est validée SERVEUR
 * (submit-dag-answer) — ici on ne sait pas lesquels sont bons.
 */
import { useState } from 'react';
import { cn } from '@jeraisonne/ui';
import { MarkdownMath } from '@jeraisonne/ui';
import { Fish, Check } from 'lucide-react';
import type { PlayerIndice } from './types';

export function IndiceFisher({
  indices,
  selected,
  onToggle,
}: {
  indices: PlayerIndice[];
  selected: Set<string>;
  onToggle: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  if (indices.length === 0) return null;

  return (
    <div className="border-ink-200 rounded-xl border bg-white">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="text-ink-700 flex min-h-[2.75rem] w-full items-center justify-between gap-2 px-3 text-sm font-semibold active:scale-[0.99]"
      >
        <span className="flex items-center gap-1.5">
          <Fish className="text-primary-500 h-4 w-4" />
          Pêcher un indice {selected.size > 0 ? `(${selected.size})` : ''}
        </span>
        <span className="text-ink-400 text-xs">{open ? 'masquer' : 'afficher'}</span>
      </button>

      {open && (
        <ul className="space-y-1.5 px-3 pb-3">
          {indices.map((i) => {
            const isSel = selected.has(i.id);
            return (
              <li key={i.id}>
                <button
                  type="button"
                  onClick={() => onToggle(i.id)}
                  aria-pressed={isSel}
                  className={cn(
                    'flex min-h-[2.75rem] w-full items-center gap-2 rounded-lg border px-3 py-2 text-left text-sm active:scale-[0.99]',
                    isSel
                      ? 'border-primary-300 bg-primary-50 text-primary-700'
                      : 'border-ink-200 text-ink-700 bg-white',
                  )}
                >
                  <span
                    className={cn(
                      'flex h-5 w-5 shrink-0 items-center justify-center rounded-full border',
                      isSel ? 'border-primary-500 bg-primary-500 text-white' : 'border-ink-300',
                    )}
                  >
                    {isSel && <Check className="h-3 w-3" />}
                  </span>
                  <span className="flex-1">
                    <MarkdownMath>
                      {i.valeur ?? `indice ${i.span_debut}–${i.span_fin}`}
                    </MarkdownMath>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
